/*
* @Author: Jasonm
* @Date:   2019-08-22
* Created by NEXT of f2e@midea
*/

'use strict';
var func = require('../module/func');
var wx = require('weixin-js-sdk');          // 微信小程序sdk
var IsWxMiniProgram = false;
var miniapp = func.getUrlParam('miniapp');  // 小程序类别，默认商城小程序midea,portal为会员小程序
window.miniapp = miniapp
var portalPathList = require('./portalPathList');


var link = {
      bindEvent:function(){
            $('.js-widget-link,.widget_link').on('click',function(){//热链控件
                  var $link = $(this).find('.link_a');
                  var isCart = $link.hasClass('js_widget_cart');
                  var href = $link.attr('href');
                  // $link.attr('href','javascript:;');
                  let itemid = func.getUrlParam('itemid');
                  itemid =itemid?itemid:func.getUrlParam('itemid',href);
                  let urlSplits = href.split('?');
                  let hostPath = urlSplits[0] ?  urlSplits[0] : '';
                  let hashStr = decodeURIComponent(urlSplits && urlSplits[1]?urlSplits[1]:'');

                  let appid = $link.attr('data-appid');  
                  var navigateUrl = '';

                  //跳转会员原生页面配置
                  if(portalPathList.indexOf(hostPath) >= 0){
                     navigateUrl = hostPath + '?' + hashStr;
                     wx.miniProgram.navigateTo({
                            url:navigateUrl,
                      });
                      return false;
                  }

                  //跳转商城原生页面配置
                  else if(href.indexOf('/page/index/index')>-1){//首页
                        
                       navigateUrl = '/page/index/index';
                        
                  }
                  else if(href.indexOf('/pages/act/sign/sign')>-1){//
                        
                       navigateUrl = '/pages/act/sign/sign?'+hashStr;
                        
                  }
                  else if(href.indexOf('/pages/act/score/exchange_detail/exchange_detail')>-1){//我的优惠券
                        
                       navigateUrl = '/pages/act/score/exchange_detail/exchange_detail?'+hashStr;
                        
                  }
                  else if(href.indexOf('subpackage/page/user/coupon/coupon')>-1){//我的优惠券
                        
                       navigateUrl = '/subpackage/page/user/coupon/coupon';
                        
                  }
                  else if(href.indexOf('/subpackage/page/user/pro/detail/detail')>-1){//我的会员
                        
                       navigateUrl = '/subpackage/page/user/pro/detail/detail';
                        
                  }
                  else if(href.indexOf('/detail/index/sale')>-1){//预售商详
                        
                       navigateUrl = '/page/detail/detail?type=sale&itemid='+itemid;
                        
                  }
                  else if(href.indexOf('/detail/index/package_list')>-1){//套装页面
                        
                       navigateUrl = '/page/package_list/package_list?'+hashStr;
                        
                  }
                  else if(href.indexOf('/detail/index/miao')>-1){//秒杀商详
                        
                       navigateUrl = '/page/detail/detail?type=miao&itemid='+itemid;
                        
                  }else if(href.indexOf('search')>-1){//搜索页
                        
                       navigateUrl = '/page/search/search_sku/search_sku?'+hashStr;
                        
                  }else if(href.indexOf('category')>-1){//品类搜索
                        
                       navigateUrl = '/page/search/categoryIndex/category?'+hashStr;
                        
                  }
                  else if(href.indexOf('/detail/index')>-1){//普通商详
                        console.log(itemid);
                        console.log('普通商详');
                        
                       navigateUrl = '/page/detail/detail?itemid='+itemid;
                        
                  }
                  else if(/\/[0-9]{22}\.html/.test(href)){//普通商详2
                        
                        let itemid = /[0-9]{22}\.html/.exec(href)[0].replace('.html','');
                        console.log('普通商详');
                        console.log(itemid);
                       navigateUrl = '/page/detail/detail?itemid='+itemid;
                        
                  }
                  else if(href.indexOf('/next/tuan/active2')>-1){//pintuan detail
                        
                       let id = func.getUrlParam('id',href);

                       navigateUrl = '/activity/page/tuan/detail/detail?saler_activeid='+ id;
                        
                  }                              
	  else if(href.indexOf('confirmorder')>-1){//确认订单页
                        
                        console.log('确认订单页');
                        console.log(hashStr);
                       navigateUrl = '/page/detail/detail?itemid='+hashStr;
                        
                  }
                  else if(href.indexOf('/promote/promote')>-1){//其他卖场页
                        // console.log(itemid);
                        let id = func.getUrlParam('id',href);
                        console.log('其他卖场页');
                        
                       navigateUrl = '/page/web_view_promote/web_view_promote?id='+id;
                        
                  }else if(href.indexOf('/cart?')>-1){//购物车
                        console.log(itemid);
                        console.log('购物车');
                        
                       navigateUrl = '/page/cart/cart?itemid='+itemid;
                        
                  }else if(isCart) {//加入购物车
                        return false;
                  }else {//其他URL
                        window.location.href = href;
                        return false;
                  }
                 if(miniapp == 'portal'){//当前为会员小程序，卖场页参数
                      wx.miniProgram.navigateTo({
                            url:'/pages/web_view_promote/web_view_promote?mpappid=wx255b67a1403adbc2'+'&mppath='+encodeURIComponent(navigateUrl),
                      });
                      return false; 
                  }else{//默认商城小程序
			if(appid){
                          wx.miniProgram.navigateTo({
                            url:'/page/web_view_promote/web_view_promote?mpappid='+appid+'&mppath='+encodeURIComponent(navigateUrl),
                          });
                          return false;
                        }                                    if(href.indexOf('/cart?')>-1){//购物车
                          wx.miniProgram.switchTab({
                                url:navigateUrl,
                          });
                          return false;
                        }
                        wx.miniProgram.navigateTo({
                              url:navigateUrl,
                        });
                        return false;
                  }
                  
                  
            });
      },
      init:function(){
            this.bindEvent();
      }
}

var widgets4Link = {//商品池列表，套装商品池列表，秒杀列表,//预售列表,图片控件
      bindEvent:function(){
            $('.widget-pool-goodslist,.js-pool-miao-v2,.js-pool-presell,.widget_img_link').on('click','a',function(){
                  var $link = $(this);
                  var href = $link.attr('href');
                  // $link.attr('href','javascript:;');
                  let itemid = func.getUrlParam('itemid');
                  let urlSplits = href.split('?');
                  let hashStr = urlSplits && urlSplits[1]?urlSplits[1]:'';
                  let appid = $link.attr('data-appid');  
                  var navigateUrl = '';
                  if(href.indexOf('/detail/index/sale')>-1){//预售商详
                        
                        navigateUrl = '/page/detail/detail?type=sale&'+hashStr;
                        
                  }else if(href.indexOf('/detail/index/miao')>-1){//秒杀商详
                        
                        navigateUrl = '/page/detail/detail?type=miao&'+hashStr;
                        
                  }
                  else if(href.indexOf('/detail/index')>-1){//普通商详
                        console.log(itemid);
                        console.log('普通商详');
                        
                        navigateUrl = '/page/detail/detail?'+hashStr;
                        
                  }

                  else {//其他URL
                        window.location.href = href;
                        return false;
                  }
                  if(miniapp == 'portal'){//当前为会员小程序，卖场页参数
                    wx.miniProgram.navigateTo({
                        url:'/pages/web_view_promote/web_view_promote?mpappid=wx255b67a1403adbc2'+'&mppath='+encodeURIComponent(navigateUrl),
                    });
                  }else{//商城小程序
                    wx.miniProgram.navigateTo({
                      url:navigateUrl,
                    });
                    return false;
                  }
            })
      },
      init:function(){
            this.bindEvent();
      },
}

var mimiProgram = {
      bindTipBtnEvent:function(){
            $('.tip_btn').on('click',function(){
                  var $link = $(this);
                  var href = $link.attr('href');
                  // $link.attr('href','javascript:;');
                  // let itemid = func.getUrlParam('itemid');
                  let urlSplits = href.split('?');
                  let hashStr = urlSplits && urlSplits[1]?urlSplits[1]:'';
                  if(href.indexOf('/cart?')>-1){//跳转购物车
                        navigateUrl='/page/cart/cart?'+hashStr;
                  }
                  if(miniapp == 'portal'){//当前为会员小程序，卖场页参数
                    wx.miniProgram.navigateTo({
                        url:'/pages/web_view_promote/web_view_promote?mpappid=wx255b67a1403adbc2'+'&mppath='+encodeURIComponent(navigateUrl),
                    });
                  }else{//商城小程序
                    if(href.indexOf('/cart?')>-1){//购物车
                          wx.miniProgram.switchTab({
                                url:navigateUrl,
                          });
                          return false;
                        }
                    wx.miniProgram.navigateTo({
                      url:navigateUrl,
                    });
                    return false;
                  }
            })
      }
};

wx.miniProgram.getEnv(function(res) { 
  IsWxMiniProgram = res.miniprogram;
  console.log(res.miniprogram);
  if(IsWxMiniProgram){
    link.init();
    widgets4Link.init();

  }
});
module.exports = mimiProgram;


// WEBPACK FOOTER //
// ./module/miniprogram.js